export const handleAuthenticationInterceptor = (request) => {
  const jwtToken = localStorage.getItem('jwtToken');
  if (jwtToken) {
    request.headers.common['x-auth-token'] = jwtToken;
  }

  return request;
};
